@if (course().courseimage) {
    <ion-avatar slot="start">
        <img [url]="course().courseimage" core-external-content alt="" (error)="loadFallbackCourseIcon()" />
    </ion-avatar>
} @else {
    <ion-icon name="fas-graduation-cap" slot="start" aria-hidden="true" />
}
